import heading from "./heading";
import form from "./form";
import setContactAgreeCheck from "./setContactAgreeCheck";
import setRadioUrl from "./setRadioUrl";

export default function contact() {
  const target = document.querySelector(".is-contact");

  if (!target) return;

  heading();
  form();
  setContactAgreeCheck();
  setRadioUrl();
}
